import { render, staticRenderFns } from "./Prevalent.vue?vue&type=template&id=000796ea&scoped=true"
import script from "./Prevalent.vue?vue&type=script&lang=js"
export * from "./Prevalent.vue?vue&type=script&lang=js"
import style0 from "./Prevalent.vue?vue&type=style&index=0&id=000796ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000796ea",
  null
  
)

export default component.exports